import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M8.83333 4.66667C8.83333 4.20643 8.46024 3.83333 8 3.83333C7.53976 3.83333 7.16667 4.20643 7.16667 4.66667V8.41667C7.16667 8.8769 7.53976 9.25 8 9.25H11.3333C11.7936 9.25 12.1667 8.8769 12.1667 8.41667C12.1667 7.95643 11.7936 7.58333 11.3333 7.58333H8.83333V4.66667Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM13.8333 8C13.8333 11.2217 11.2217 13.8333 8 13.8333C4.77834 13.8333 2.16667 11.2217 2.16667 8C2.16667 4.77834 4.77834 2.16667 8 2.16667C11.2217 2.16667 13.8333 4.77834 13.8333 8Z",
  fill: "white"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}